$(document).ready(function () {
  if ($('.magazine_slider').length && $.fn.slick) {
    $('.magazine_slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  if ($('.smartf-column-case-cards:not(.no-slick)').length && $.fn.slick) {
    $('.smartf-column-case-cards:not(.no-slick)').slick({
      arrows: true,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  if ($('.smartf-column-cards:not(.no-slick)').length && $.fn.slick) {
    $('.smartf-column-cards:not(.no-slick)').slick({
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  $('.sidebar.column .sidebar_one ul li a.search-from').on('click', function () {
    $(this).toggleClass('close');
    $(this).next().toggleClass('close');
  });
});
